import { useLayoutEffect, useRef, useState } from 'react'

function scrollParent(node: HTMLElement): HTMLElement | null {
  let el = node.parentElement
  while (el) {
    const { overflowY } = getComputedStyle(el)
    if (overflowY === 'auto' || overflowY === 'scroll') return el
    el = el.parentElement
  }
  return null
}

export function useFillViewportHeight<T extends HTMLElement>() {
  const ref = useRef<T>(null)
  const [minHeight, setMinHeight] = useState<number | undefined>(undefined)

  useLayoutEffect(() => {
    const node = ref.current
    if (!node) return
    const scroller = scrollParent(node)
    const shell = node.closest<HTMLElement>(':has(> footer)') ?? document.body

    const measure = () => {
      const viewport = scroller?.clientHeight ?? window.innerHeight
      const chrome = shell.offsetHeight - node.offsetHeight
      const next = Math.max(0, viewport - chrome)
      setMinHeight((prev) => (prev === next ? prev : next))
    }

    measure()
    const observer = new ResizeObserver(measure)
    if (scroller) observer.observe(scroller)
    observer.observe(shell)
    window.addEventListener('resize', measure)
    return () => {
      observer.disconnect()
      window.removeEventListener('resize', measure)
    }
  }, [])

  return { ref, minHeight }
}
